import * as React from 'react'
import { Button, Paper, Box } from '@mui/material'
import { BlockTitle } from '../../components/UI/BlockTitle/BlockTitle'
import { Link } from 'react-router-dom'
export default function Reports() {
  return (
    <>
      <Paper
        sx={{ padding: '1rem', borderRadius: '1rem', mt: 3 }}
        elevation={0}
      >
        <Box display="flex" flexDirection="column">
          <BlockTitle backUrl="/" label="Отчёты" />
          <Box mt={3} display="flex" flexDirection="column" gap={2}>
            <Link to="/stage-reports">
              <Button
                sx={{
                  textTransform: 'none',
                  height: 'fit-content',
                  width: '400px'
                }}
                variant="contained"
                color="info"
              >
                Количество выполненных стадий по сотрудникам
              </Button>
            </Link>
            <Link to="/recovery-report">
              <Button
                sx={{
                  textTransform: 'none',
                  height: 'fit-content',
                  width: '400px'
                }}
                variant="contained"
                color="info"
              >
                Отчёт для взыскания
              </Button>
            </Link>
            <Link to="/signed-contracts-report">
              <Button
                sx={{
                  textTransform: 'none',
                  height: 'fit-content',
                  width: '400px'
                }}
                variant="contained"
                color="info"
              >
                Отчёт по подписанным договорам
              </Button>
            </Link>
          </Box>
        </Box>
      </Paper>
    </>
  )
}
